// extracted by mini-css-extract-plugin
module.exports = {"UserPopup":"UserPopup_UserPopup__3GaC0","arrow-up":"UserPopup_arrow-up__2ZnGp","btn":"UserPopup_btn__UNWcE","noBorder":"UserPopup_noBorder__3s6Bq","text":"UserPopup_text__LznjK"};